import { Area, AreaChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import type { TrendPoint } from "@/types";

export default function TrendChart({ data }: { data: TrendPoint[] }) {
  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-5">
      <div className="mb-4 flex flex-wrap items-center justify-between gap-3">
        <div>
          <h3 className="font-heading text-base font-semibold text-foreground-950">近 7 天点击趋势</h3>
          <p className="mt-1 text-xs text-foreground-500">总点击与独立访客的每日变化</p>
        </div>
        <div className="flex items-center gap-4 text-xs text-foreground-600">
          <span className="flex items-center gap-1.5">
            <span className="h-2 w-2 rounded-full bg-primary-500" />
            总点击
          </span>
          <span className="flex items-center gap-1.5">
            <span className="h-2 w-2 rounded-full bg-accent-500" />
            独立访客
          </span>
        </div>
      </div>
      <div className="h-64 w-full">
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart data={data} margin={{ top: 8, right: 8, left: -18, bottom: 0 }}>
            <defs>
              <linearGradient id="fillClicks" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="oklch(var(--primary-500))" stopOpacity={0.35} />
                <stop offset="95%" stopColor="oklch(var(--primary-500))" stopOpacity={0} />
              </linearGradient>
              <linearGradient id="fillUnique" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="oklch(var(--accent-500))" stopOpacity={0.3} />
                <stop offset="95%" stopColor="oklch(var(--accent-500))" stopOpacity={0} />
              </linearGradient>
            </defs>
            <CartesianGrid strokeDasharray="3 3" stroke="oklch(var(--background-300))" vertical={false} />
            <XAxis dataKey="date" tick={{ fontSize: 12, fill: "oklch(var(--foreground-500))" }} axisLine={false} tickLine={false} />
            <YAxis tick={{ fontSize: 12, fill: "oklch(var(--foreground-500))" }} axisLine={false} tickLine={false} />
            <Tooltip
              contentStyle={{
                borderRadius: 8,
                border: "1px solid oklch(var(--background-300))",
                fontSize: 12,
                background: "oklch(var(--background-50))",
                color: "oklch(var(--foreground-950))",
              }}
            />
            <Area type="monotone" dataKey="clicks" name="总点击" stroke="oklch(var(--primary-500))" strokeWidth={2} fill="url(#fillClicks)" />
            <Area type="monotone" dataKey="unique" name="独立访客" stroke="oklch(var(--accent-500))" strokeWidth={2} fill="url(#fillUnique)" />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}